import CommandBar from './CommandBar';

export default CommandBar;
